<app-layout>
  @if (showCalendar) {
    <app-calendar></app-calendar>
  }

  <app-services-table></app-services-table>
</app-layout>
